import styles from "./Sidebar.module.scss";
import { BsColumnsGap, BsFileBarGraph, BsGear } from "react-icons/bs";
import {
  FiChevronLeft as LeftIcon,
  FiChevronRight as RightIcon,
} from "react-icons/fi";
import { GASendEvent, getLocalUser } from "../functions/utilities";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useLayoutEffect, useState } from "react";
import { BsPlusCircle } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import SupportIcon from "../../assets/images/supportIcon.svg";
import SupportActiveIcon from "../../assets/images/supportIcon_active.svg";
import {
  GADimensions,
  GAEvents,
  LinkType,
  UserRole,
  isFirstLogin,
} from "../../interfaces/interfaces";
import { BiQuestionMark as TutorialsIcon } from "react-icons/bi";
import WelcomeModal from "../common/WelcomeModal/WelcomeModal";
import { OverlayTrigger } from "react-bootstrap";
import { RenderSideBarTooltip } from "../common/RenderTooltip";
import goalSideBarIcon from "../../assets/images/goalSideBarIcon.svg";
import selectedGoalSideBarIcon from "../../assets/images/selectedGoalSideBarIcon.svg";
import { setRedirectUrl } from "../../redux/temporaryWorkspase/temporaryWorkspace";
import { useAppDispatch, useAppSelector } from "../../redux/reduxHooks";
import boostSideBarIcon from "../../assets/images/decisionHub/boostSidebarIcon.svg";
import { HiOutlineRocketLaunch } from "react-icons/hi2";
import { MdOutlineDashboardCustomize, MdDateRange } from "react-icons/md";
import { VscDebugDisconnect } from "react-icons/vsc";
import PcWoClickIcon from "../../assets/images/profitabilityCalculator/pcSideBarIcon.svg";
import PcClickIcon from "../../assets/images/profitabilityCalculator/profit-svgrepo-com 1 active.svg";
import { RiBankLine as UnderwritingIcon } from "react-icons/ri";
import supplierIntelligenceBlackIcon from "../../assets/images/supplierIntelligenceBlackIcon.svg";
import supplierIntelligencePurpleIcon from "../../assets/images/supplierIntelligencePurpleIcon.svg";
import { RestS } from "../../rest/rest-service";
import { FaRegMoneyBillAlt as SupplierPaymentsIcon } from "react-icons/fa";
import { setSideBarCollapse } from "../../redux/config/config";
import { fetchAgencyClients } from "../../redux/agencyConfig/agencyConfigUtil";
import { RootState } from "../../redux/store";
import { useBannerDismiss } from "../Hooks/useBannerDismiss";
import { SI_SIDEBAR_TOOLTIP_KEY, SI_PROMO_CONFIG_KEYS, isSIPromoEnabled } from "../../constants/promotionKeys";
import SIPromoTooltip from "../common/SIPromoTooltip/SIPromoTooltip";

const insideReportsRegex = /ReportDetails\/\d+/;

function Sidebar() {
  const dispatch = useDispatch();
  const appDispatch = useAppDispatch();

  const helppopup = useSelector((state: any) => state.popover);
  let user = getLocalUser();
  // const [isCollapse, setCollapse] = useState<boolean>(true);
  const [isUnderwritingInvite, setIsUnderwritingInvite] = useState(false);
  const [isMonthlyReportInvite, setIsMonthlyReportInvite] = useState(false);
  // const navigator = useNavigate();
  // const [popoverOpen, setPopoverOpen] = useState<boolean>(false);
  const [hasControlPannelAccess, setHasControlPannelAccess] =
    useState<boolean>(false);
  // const [helpPopover, setHelpPopover] = useState<any>({
  // dashboard: false,
  // reportHub: false,
  // workspace: false,
  // support: false,
  // settings: false,
  // createButton: false,
  // });
  // const gaEventTrackerCF = useAnalyticsEventTracker('Collaboration features');
  const { pathname } = useLocation();
  const [showWelcomePopup, setShowWelcomePopup] = useState(false);
  const { isTemporary, isConsolidated } = useAppSelector(
    (state) => state.temporaryWorkspace
  );
  const isTemp = useSelector((s: RootState) => s.agencyDashboard.isTemp);

  const { isSideBarCollapse, siPromoConfig } = useAppSelector((state) => state.config);

  const { temporaryJobDetails } = useAppSelector(
    (state) => state.temporaryDashboard
  );

  const navigate = useNavigate();
  const { isDismissed: siPromoDismissed, dismiss: dismissSIPromo } = useBannerDismiss(SI_SIDEBAR_TOOLTIP_KEY);
  const showSIPromo = !siPromoDismissed && !pathname.startsWith('/supplier-intelligence');

  useEffect(() => {
    if (pathname.startsWith('/supplier-intelligence') && !siPromoDismissed) {
      dismissSIPromo();
    }
  }, [pathname]);

  // useEffect(() => {
  //   dispatch(fetchingJoke())
  // }, [dispatch])
  useLayoutEffect(() => {
    window.innerWidth < 1000
      ? appDispatch(setSideBarCollapse(true))
      : appDispatch(setSideBarCollapse(true));
  }, [window.innerWidth]);
  useEffect(() => {
    // if (user?.lastLoginTime == "" || user?.lastLoginTime == null) {
    //   let log = localStorage.getItem('first_login');
    //   if (log == null && log != '1') {
    //     localStorage.setItem('first_login', '1');
    //   }

    // } else {
    //   localStorage.setItem('first_login', '0');
    // }
    // let first_login: string = localStorage.getItem('first_login')
    // if (first_login == '1') {
    //   helpPopover['dashboard'] = true
    //   setHelpPopover(helpPopover)
    //   dispatch({ type: "DASHBOARD_POPOVER", payload: helpPopover })
    //   var dashboard = document.getElementById('dashboard');
    //   dashboard.click()
    // }
    let isFirstLogin: isFirstLogin = localStorage.getItem("isFirstLogin")
      ? JSON.parse(localStorage.getItem("isFirstLogin"))
      : null;

    if (
      isFirstLogin &&
      isFirstLogin.userId.toString() == user?.id.toString() &&
      isFirstLogin.firstLogin
    ) {
      appDispatch(setSideBarCollapse(false));
      // setCollapse(false);
    }

    if (user?.role == "Admin" || user?.role == "Agency") {
      setHasControlPannelAccess(true);
    }
  }, []);

  const handleRedirect = (event: any, path: any, section_name?: string) => {
    if (
      pathname.toLowerCase().includes("reportdetails") &&
      (isTemporary || !isConsolidated)
    ) {
      event.preventDefault();
      dispatch(setRedirectUrl(path));
      return;
    }

    if (pathname == "/" && temporaryJobDetails) {
      event.preventDefault();
      dispatch(setRedirectUrl(path));
      return;
    }

    if (pathname == "/" && isTemp) {
      event.preventDefault();
      dispatch(setRedirectUrl(path));
      return;
    }

    // Send event to GA
    console.log({
      [GADimensions.userLoginId]: user.id,
      [GADimensions.userType]: user.role,
      [GADimensions.section_name]: section_name,
      [GADimensions.companyId]: user.companyId,
      [GADimensions.companyName]: user.companyName,
    });
    GASendEvent(user, GAEvents.section_click, {
      [GADimensions.userLoginId]: user.id,
      [GADimensions.userType]: user.role,
      [GADimensions.section_name]: section_name,
      [GADimensions.companyId]: user.companyId,
      [GADimensions.companyName]: user.companyName,
    });
  };

  const isProfitabilityPath = pathname.toLowerCase().includes("/pnltracker");

  useEffect(() => {
    (async () => {
      try {
        const data: any = await RestS.checkInviteType(LinkType.underwriting);
        setIsUnderwritingInvite(data?.isAccess);
      } catch (error) {
        console.log("error", error);
      }
    })();
    (async () => {
      try {
        const data: any = await RestS.checkInviteType(LinkType.monthlyReport);
        setIsMonthlyReportInvite(data?.isAccess);
      } catch (error) {
        console.log("error", error);
      }
    })();
  }, []);

  useEffect(() => {
    dispatch(fetchAgencyClients({}));
  }, []);

  const { clients } = useAppSelector((state) => state.agencyConfig);

  // console.log('clients sidebar', clients);

  return (
    <div
      id="sidebarMain"
      className={
        !isSideBarCollapse
          ? styles.sidebarMain
          : `${styles.sidebarMainCollapsed} close-sidedbar`
      }
    >
      <div className={styles.sidebar}>
        <div style={{ marginTop: "1rem" }}>
          <div
            className={`${styles.navLink}  ${helppopup["dashboard"] ? styles.helptext : ""
              }`}
          >
            {isSideBarCollapse ? (
              <OverlayTrigger
                placement="right"
                overlay={(props) => RenderSideBarTooltip(props, user?.role == UserRole.Agency ? "Perform+" : "My Dashboard")}
                delay={{ show: 100, hide: 100 }}
              >
                <NavLink
                  to={user?.role == UserRole.Agency ? "/dashboard" : "/"}
                  className={({ isActive }) => (isActive ? styles.active : "")}
                  end
                  aria-label={user?.role == UserRole.Agency ? "Perform+" : "My Dashboard"}
                  onClick={(e) => {
                    handleRedirect(e, "/", "My Dashboard");
                  }}
                >
                  <span className={styles.navIcon}>
                    <BsColumnsGap />
                  </span>
                  {!isSideBarCollapse && (
                    <>
                      <span className={`${styles.navLable}`} id="dashboard">
                        {user?.role == UserRole.Agency ? "Perform+" : "My Dashboard"}
                      </span>
                    </>
                  )}
                </NavLink>
              </OverlayTrigger>
            ) : (
              <NavLink
                to={user?.role == UserRole.Agency ? "/dashboard" : "/"}
                className={({ isActive }) => (isActive ? styles.active : "")}
                end
                aria-label={user?.role == UserRole.Agency ? "Perform+" : "My Dashboard"}
                onClick={(e) => {
                  handleRedirect(e, "/", "My Dashboard");
                }}
              >
                <span className={styles.navIcon}>
                  <BsColumnsGap />
                </span>
                {!isSideBarCollapse && (
                  <>
                    <span className={`${styles.navLable}`} id="dashboard">
                      {user?.role == UserRole.Agency ? "Perform+" : "My Dashboard"}
                    </span>
                  </>
                )}
              </NavLink>
            )}
          </div>

          <div
            className={`${styles.navLink} ${helppopup["reportHub"] ? styles.helptext : ""
              }`}
          >
            {isSideBarCollapse ? (
              <OverlayTrigger
                placement="right"
                overlay={(props) =>
                  RenderSideBarTooltip(props, "My Workspaces")
                }
                delay={{ show: 100, hide: 100 }}
              >
                <NavLink
                  to="/Reports"
                  // isActive={() => ['/Reports', '/myevents'].includes(pathname)}
                  onClick={(e) => {
                    handleRedirect(e, "/Reports", "My Workspaces");
                  }}
                  className={({ isActive }) => {
                    if (pathname.split("/")[1].includes("ReportDetails"))
                      return styles.active;
                    return isActive ? styles.active : "";
                  }}
                  aria-label="Workspace Hub"
                >
                  <span className={`${styles.navIcon} `}>
                    <BsFileBarGraph />
                  </span>
                  {!isSideBarCollapse && (
                    <span className={`${styles.navLable}`}>My Workspaces</span>
                  )}
                </NavLink>
              </OverlayTrigger>
            ) : (
              <NavLink
                to="/Reports"
                // isActive={() => ['/Reports', '/myevents'].includes(pathname)}
                onClick={(e) => {
                  handleRedirect(e, "/Reports", "My Workspaces");
                }}
                className={({ isActive }) => {
                  if (pathname.split("/")[1].includes("ReportDetails"))
                    return styles.active;
                  return isActive ? styles.active : "";
                }}
                aria-label="Workspace Hub"
              >
                {/* <span className={styles.navIcon}>
                  <BsFileBarGraph />
                  <div className={styles.newOverlay}>NEW</div>
                </span>
                {!isSideBarCollapse && (
                  <>
                    <div className={`${styles.sideNavText}`}>
                      My Workspaces
                      <div className={styles.newOverlay}>NEW</div>
                    </div>
                  </>
                )} */}
                <div className={styles.expandedSideNav}>
                  <div className={styles.navIconRc}>
                    {/* <PcWoClickIcon /> */}
                    <BsFileBarGraph />
                  </div>
                  <div className={styles.sideNavText}>
                    <p>My Workspaces</p>
                  </div>
                </div>
              </NavLink>
            )}
            <span id="workspace"></span>
          </div>
          {user?.role !== "Agency" && (
            <div
              className={`${styles.navLink} ${helppopup["workspace"] ? styles.helptext : ""
                }`}
            >
              {isSideBarCollapse ? (
                <OverlayTrigger
                  placement="right"
                  overlay={(props) => RenderSideBarTooltip(props, "Boost")}
                  delay={{ show: 100, hide: 100 }}
                >
                  <NavLink
                    to="/Boost"
                    onClick={(e) => {
                      handleRedirect(e, "/Boost", "Merito Boost");
                    }}
                    className={({ isActive }) =>
                      isActive ? styles.active : ""
                    }
                    aria-label="Boost"
                  >
                    <span className={styles.navIcon}>
                      <HiOutlineRocketLaunch />
                      {/* <div className={styles.newOverlay}>NEW</div> */}
                    </span>
                  </NavLink>
                </OverlayTrigger>
              ) : (
                <NavLink
                  to="/Boost"
                  className={({ isActive }) => (isActive ? styles.active : "")}
                  onClick={(e) => {
                    handleRedirect(e, "/Boost", "Merito Boost");
                  }}
                  aria-label="Boost"
                >
                  <div className={styles.expandedSideNav}>
                    <div className={styles.navIconRc}>
                      <HiOutlineRocketLaunch />
                    </div>

                    <div className={styles.sideNavText}>
                      <p>Boost</p>
                      {/* <div className={styles.expandedOverlay}>NEW</div> */}
                    </div>
                  </div>
                </NavLink>
              )}
            </div>
          )}
          {user?.role !== "Agency" && (
            <div
              className={`${styles.navLink} ${helppopup["workspace"] ? styles.helptext : ""
                }`}
            >
              {isSideBarCollapse ? (
                <OverlayTrigger
                  placement="right"
                  overlay={(props) =>
                    RenderSideBarTooltip(props, "P&L Tracker")
                  }
                  delay={{ show: 100, hide: 100 }}
                >
                  <NavLink
                    to="/pnltracker"
                    onClick={(e) => {
                      handleRedirect(e, "/pnltracker", "P&L Tracker");
                    }}
                    className={({ isActive }) =>
                      isActive ? styles.active : ""
                    }
                    aria-label="P&L Tracker"
                  >
                    <span className={styles.navIcon}>
                      <img
                        src={isProfitabilityPath ? PcClickIcon : PcWoClickIcon}
                        alt=""
                      />
                      {/* <div className={styles.newOverlay}>NEW</div> */}
                    </span>
                  </NavLink>
                </OverlayTrigger>
              ) : (
                <NavLink
                  to="/pnltracker"
                  onClick={(e) => {
                    handleRedirect(e, "/pnltracker", "P&L Tracker");
                  }}
                  className={({ isActive }) => (isActive ? styles.active : "")}
                  aria-label="P&L Tracker"
                >
                  <div className={styles.expandedSideNav}>
                    <div className={styles.navIconRc}>
                      {/* <PcWoClickIcon /> */}
                      <img
                        src={isProfitabilityPath ? PcClickIcon : PcWoClickIcon}
                        alt=""
                      />
                    </div>

                    <div className={styles.sideNavText}>
                      <p>P&L Tracker</p>
                    </div>
                  </div>
                </NavLink>
              )}
            </div>
          )}

          {user?.role !== "Agency" && (
            <div className={`${styles.navLink}`}>
              {isSideBarCollapse ? (
                <OverlayTrigger
                  placement="right"
                  overlay={(props) => RenderSideBarTooltip(props, "Supplier Intelligence")}
                  delay={{ show: 100, hide: 100 }}
                >
                  <NavLink
                    to="/supplier-intelligence"
                    onClick={(e) => {
                      dismissSIPromo();
                      if (pathname.startsWith("/supplier-intelligence/")) { e.preventDefault(); return; }
                      handleRedirect(e, "/supplier-intelligence", "Supplier Intelligence");
                    }}
                    className={({ isActive }) => (isActive ? styles.active : "")}
                    aria-label="Supplier Intelligence"
                  >
                    {({ isActive }) => (
                      <span className={styles.navIcon}>
                        <img
                          src={isActive ? supplierIntelligencePurpleIcon : supplierIntelligenceBlackIcon}
                          alt=""
                          className={styles.supplierNavIcon}
                          data-si-promo-anchor="true"
                        />
                        <div className={`${styles.newOverlay} ${styles.alignLeft}`}>NEW</div>
                      </span>
                    )}
                  </NavLink>
                </OverlayTrigger>
              ) : (
                <NavLink
                  to="/supplier-intelligence"
                  onClick={(e) => {
                    dismissSIPromo();
                    if (pathname.startsWith("/supplier-intelligence/")) { e.preventDefault(); return; }
                    handleRedirect(e, "/supplier-intelligence", "Supplier Intelligence");
                  }}
                  className={({ isActive }) => (isActive ? styles.active : "")}
                  aria-label="Supplier Intelligence"
                >
                  {({ isActive }) => (
                    <div className={styles.expandedSideNav}>
                      <div className={styles.navIconRc}>
                        <img
                          src={isActive ? supplierIntelligencePurpleIcon : supplierIntelligenceBlackIcon}
                          alt=""
                          className={styles.supplierNavIcon}
                          data-si-promo-anchor="true"
                        />
                      </div>
                      <div className={styles.sideNavText}>
                        <p>Supplier Intelligence</p>
                        <div className={styles.expandedOverlay}>NEW</div>
                      </div>
                    </div>
                  )}
                </NavLink>
              )}
            </div>
          )}
          {showSIPromo && isSIPromoEnabled(siPromoConfig, SI_PROMO_CONFIG_KEYS.TOOLTIP_SIDEBAR) && (
            <SIPromoTooltip
              isSidebarCollapsed={!!isSideBarCollapse}
              onDismiss={dismissSIPromo}
              onCheckItOut={() => navigate('/supplier-intelligence')}
            />
          )}

          {user?.role !== "Agency" && isUnderwritingInvite && (
            <div
              className={`${styles.navLink} ${helppopup["workspace"] ? styles.helptext : ""
                }`}
            >
              {isSideBarCollapse ? (
                <OverlayTrigger
                  placement="right"
                  overlay={(props) =>
                    RenderSideBarTooltip(props, "Merito Investment")
                  }
                  delay={{ show: 100, hide: 100 }}
                >
                  <NavLink
                    to="/underwriting"
                    onClick={(e) => {
                      handleRedirect(e, "/underwriting", "Underwriting");
                    }}
                    className={({ isActive }) =>
                      isActive ? styles.active : ""
                    }
                    aria-label="Underwriting"
                  >
                    <span className={styles.navIcon}>
                      <SupplierPaymentsIcon />
                    </span>
                  </NavLink>
                </OverlayTrigger>
              ) : (
                <NavLink
                  to="/underwriting"
                  onClick={(e) => {
                    handleRedirect(e, "/underwriting", "Underwriting");
                  }}
                  className={({ isActive }) => (isActive ? styles.active : "")}
                  aria-label="Underwriting"
                >
                  <div className={styles.expandedSideNav}>
                    <div className={styles.navIconRc}>
                      <SupplierPaymentsIcon />
                    </div>
                    <div className={styles.sideNavText}>
                      <p>Merito Investment</p>
                    </div>
                  </div>
                </NavLink>
              )}
            </div>
          )}

          {user?.role !== "Agency" && isMonthlyReportInvite && (
            <div
              className={`${styles.navLink} ${helppopup["workspace"] ? styles.helptext : ""
                }`}
            >
              {isSideBarCollapse ? (
                <OverlayTrigger
                  placement="right"
                  overlay={(props) =>
                    RenderSideBarTooltip(props, "Monthly Report")
                  }
                  delay={{ show: 100, hide: 100 }}
                >
                  <NavLink
                    to="/monthlyReport"
                    onClick={(e) => {
                      handleRedirect(e, "/monthlyReport", "Monthly Report");
                    }}
                    className={({ isActive }) =>
                      isActive ? styles.active : ""
                    }
                    aria-label="Monthly Report"
                  >
                    <span className={styles.navIcon}>
                      <MdDateRange />
                      {insideReportsRegex?.test(pathname) ? null : (
                        <div
                          className={`${styles.roundOverlay} ${styles.alignLeft}`}
                        ></div>
                      )}
                    </span>
                  </NavLink>
                </OverlayTrigger>
              ) : (
                <NavLink
                  to="/monthlyReport"
                  onClick={(e) => {
                    handleRedirect(e, "/monthlyReport", "Monthly Report");
                  }}
                  className={({ isActive }) => (isActive ? styles.active : "")}
                  aria-label="Monthly Report"
                >
                  <div className={styles.expandedSideNav}>
                    <div className={styles.navIconRc}>
                      <MdDateRange />
                    </div>
                    <div className={styles.sideNavText}>
                      <p>Monthly Report</p>
                      {insideReportsRegex?.test(pathname) ? null : (
                        <div className={styles.expandedRoundOverlay}></div>
                      )}
                    </div>
                  </div>
                </NavLink>
              )}
            </div>
          )}

          {hasControlPannelAccess && (
            <div
              className={`${styles.navLink}  ${helppopup["settings"] ? styles.helptext : ""
                }`}
            >
              {isSideBarCollapse ? (
                <OverlayTrigger
                  placement="right"
                  overlay={(props) =>
                    RenderSideBarTooltip(props, "Control Panel")
                  }
                  delay={{ show: 100, hide: 100 }}
                >
                  <NavLink
                    to="/Settings"
                    onClick={(e) => {
                      handleRedirect(e, "/Settings", "Control Panel");
                    }}
                    className={({ isActive }) =>
                      isActive ? styles.active : ""
                    }
                    aria-label="Control panel"
                  >
                    <span className={styles.navIcon}>
                      <BsGear />
                    </span>
                    {!isSideBarCollapse && (
                      <span className={`${styles.navLable}`}>
                        Control Panel
                      </span>
                    )}
                  </NavLink>
                </OverlayTrigger>
              ) : (
                <NavLink
                  to="/Settings"
                  onClick={(e) => {
                    handleRedirect(e, "/Settings", "Control Panel");
                  }}
                  className={({ isActive }) => (isActive ? styles.active : "")}
                  aria-label="Control panel"
                >
                  <span className={styles.navIcon}>
                    <BsGear />
                  </span>
                  {!isSideBarCollapse && (
                    <span className={`${styles.navLable}`}>Control Panel</span>
                  )}
                </NavLink>
              )}
              <span id="settings"></span>
            </div>
          )}

          {user?.role == UserRole.Agency && !clients.length ? null : (
            <div
              className={`${styles.storeNav} ${isSideBarCollapse ? "" : styles.notCollapsedStoreNav
                }`}
            >
              {isSideBarCollapse ? (
                <OverlayTrigger
                  placement="right"
                  overlay={(props) =>
                    RenderSideBarTooltip(props, "Connect Account")
                  }
                  delay={{ show: 100, hide: 100 }}
                >
                  <NavLink
                    to="/workspaceStore"
                    className={styles.wsStore}
                    aria-label="Connect Account"
                    onClick={(e) => {
                      handleRedirect(e, "/WorkspaceStore", "Connect Account");
                    }}
                  // style={{ pointerEvents: 'none' }}
                  >
                    {!isSideBarCollapse ? (
                      <span className={`${styles.navLable}`}>Connect</span>
                    ) : (
                      <span
                        style={{
                          marginRight: !isSideBarCollapse ? "10px" : "0px",
                        }}
                        className={styles.navIcon}
                      >
                        <VscDebugDisconnect
                          style={{ width: "1rem", height: "1rem" }}
                        />
                      </span>
                    )}
                  </NavLink>
                </OverlayTrigger>
              ) : (
                <NavLink
                  to="/workspaceStore"
                  className={styles.wsStore}
                  aria-label="Connect Account"
                  onClick={(e) => {
                    handleRedirect(e, "/WorkspaceStore", "Connect Account");
                  }}
                // style={{ pointerEvents: 'none' }}
                >
                  {!isSideBarCollapse ? (
                    <span className={`${styles.navLable}`}>Connect</span>
                  ) : (
                    <span
                      style={{
                        marginRight: !isSideBarCollapse ? "10px" : "0px",
                      }}
                      className={styles.navIcon}
                    >
                      <BsPlusCircle />
                    </span>
                  )}
                </NavLink>
              )}
            </div>
          )}
        </div>
        <div className={styles.tutorialsIconMain}>
          <div className={styles.innerContainer}>
            <hr className={styles.supportHr} />
            <div
              className={`${styles.navLink}  ${helppopup["support"] ? styles.helptext : ""
                }`}
            >
              {isSideBarCollapse ? (
                <OverlayTrigger
                  placement="right"
                  overlay={(props) => RenderSideBarTooltip(props, "Support")}
                  delay={{ show: 100, hide: 100 }}
                >
                  <NavLink
                    to="/support"
                    onClick={(e) => {
                      handleRedirect(e, "/Support", "Support");
                    }}
                    className={({ isActive }) =>
                      isActive ? styles.active : ""
                    }
                    aria-label="Support"
                  >
                    {({ isActive }) => (
                      <>
                        <span className={styles.navIcon}>
                          <img
                            style={{ width: "24px" }}
                            src={isActive ? SupportActiveIcon : SupportIcon}
                            alt=""
                          />
                        </span>

                        {!isSideBarCollapse && (
                          <span className={`${styles.navLable}`}>Support</span>
                        )}
                      </>
                    )}
                  </NavLink>
                </OverlayTrigger>
              ) : (
                <NavLink
                  to="/support"
                  className={({ isActive }) => (isActive ? styles.active : "")}
                  onClick={(e) => {
                    handleRedirect(e, "/Support", "Support");
                  }}
                  aria-label="Support"
                >
                  {({ isActive }) => (
                    <>
                      <span className={styles.navIcon}>
                        <img
                          style={{ width: "24px" }}
                          src={isActive ? SupportActiveIcon : SupportIcon}
                          alt=""
                        />
                      </span>

                      {!isSideBarCollapse && (
                        <span className={`${styles.navLable}`}>Support</span>
                      )}
                    </>
                  )}
                </NavLink>
              )}

              <span id="support"></span>
            </div>
            <div
              className={`${styles.navLink}  ${helppopup["support"] ? styles.helptext : ""
                }`}
            >
              {isSideBarCollapse ? (
                <OverlayTrigger
                  placement="right"
                  overlay={(props) => RenderSideBarTooltip(props, "Help")}
                  delay={{ show: 100, hide: 100 }}
                >
                  <div
                    // to="/help"
                    // className={({ isActive }) => (isActive ? styles.active : "")}
                    onClick={() => setShowWelcomePopup(!showWelcomePopup)}
                    aria-label="Help"
                  >
                    <span className={styles.navIcon}>
                      <TutorialsIcon style={{ width: "24px" }} />
                    </span>
                  </div>
                </OverlayTrigger>
              ) : (
                <div
                  // to="/help"
                  // className={({ isActive }) => (isActive ? styles.active : "")}
                  onClick={() => setShowWelcomePopup(!showWelcomePopup)}
                  aria-label="Help"
                >
                  <span className={styles.navIcon}>
                    <TutorialsIcon style={{ width: "24px" }} />
                  </span>

                  {!isSideBarCollapse && (
                    <span className={`${styles.navLable}`}>Help</span>
                  )}
                </div>
              )}

              <span id="help"></span>
            </div>
          </div>
        </div>
        {showWelcomePopup && (
          <WelcomeModal
            modalVisible={showWelcomePopup}
            onClose={() => setShowWelcomePopup(false)}
          />
        )}

        <span
          className={!isSideBarCollapse ? styles.badge : styles.badgee}
          onClick={() => {
            appDispatch(setSideBarCollapse(!isSideBarCollapse));
            // setCollapse(!isCollapse);
          }}
        >
          {isSideBarCollapse ? <RightIcon /> : <LeftIcon />}
        </span>
      </div>
    </div>
  );
}

export default Sidebar;
